import { useLocation } from 'react-router-dom';

const STEPS = ['Design', 'Editor', 'Details', 'Kasse'];

function activeStep(pathname: string): number {
  if (pathname.startsWith('/design')) return 0;
  if (pathname.startsWith('/editor')) return 1;
  if (pathname.startsWith('/checkout')) return 2;
  if (pathname.startsWith('/order/')) return 3;
  return -1;
}

export function StepIndicator() {
  const { pathname } = useLocation();
  const current = activeStep(pathname);

  if (current === -1) return null;

  return (
    <div className="step-indicator">
      {STEPS.map((label, i) => (
        <span key={label} className="step-wrap" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          {i > 0 && <span className="step-line" />}
          <span
            className={`step${i === current ? ' active' : i < current ? ' done' : ''}`}
          >
            <span className="step-circle">{i < current ? '✓' : i + 1}</span>
            <span>{label}</span>
          </span>
        </span>
      ))}
    </div>
  );
}
